import type { FlightOccurrenceEventKind, FlightOccurrenceEventTriggerReference, ServiceDay, Severity } from "../../../domain/types";

export type GmView = "events" | "flights" | "aircraft" | "airports" | "world" | "audit";
export type FilterAll<T extends string> = "all" | T;

export const SERVICE_DAY_ORDER: ServiceDay[] = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const SEVERITY_VALUES: Severity[] = ["info", "watch", "warning", "critical"];
export const OCCURRENCE_EVENT_KIND_VALUES: FlightOccurrenceEventKind[] = ["weather", "mechanical", "medical_transfer", "security", "airport_visibility", "ops"];
export const OCCURRENCE_TRIGGER_REFERENCE_VALUES: FlightOccurrenceEventTriggerReference[] = ["ground_service_start", "takeoff"];

export const GM_VIEWS: Array<{ id: GmView; label: string }> = [
  { id: "events", label: "事件" },
  { id: "flights", label: "航班" },
  { id: "aircraft", label: "飞机" },
  { id: "airports", label: "机场" },
  { id: "world", label: "资料" },
  { id: "audit", label: "审计" }
];
